/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function ($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');

	var modules = {};
	var components = {};
	var pages = {};

	const toggleSwitch = document.getElementById('toggle-switch');
	if (toggleSwitch != null && toggleSwitch != undefined) {
		var updateField = toggleSwitch.getAttribute("update-field");

		toggleSwitch.addEventListener('change', function () {
			$("input[name='" + updateField + "']").val(toggleSwitch.checked ? "a" : "i");
		});
	}


	/* Modules */
	var createModule = function (module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageChange: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};

	var exportModule = function (key, module) {
		modules[key] = createModule(module);

		return modules[key];
	};


	/* Pages */
	var createPage = function (page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};

	var exportPage = function (key, page) {
		pages[key] = createPage(page);

		return pages[key];
	};

	var checkForPage = function (pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num=' + pageIdNum + ']').attr('data-page-id');

		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-' + currPage);
			pages[pageIdNum].pageLoad('#page-' + currPage);
		}
	};


	/* Components */
	var createComponent = function (component) {
		return $.extend({ init: $.noop }, component);
	};

	var exportComponent = function (key, component) {
		components[key] = createPage(component);

		return pages[key];
	};


	var start = function () {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');

		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');

		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}

		currPathname = currPathname !== '/' ? currPathname : 'home';

		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}

		if (lang !== defaultLang) {
			if (currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('/')[0];

		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});

		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);

		return Fw;
	};

	global.Fw = $.extend(global.Fw, {
		data: '',

		modules: {
			models: function () {
				return modules;
			},

			export: exportModule
		},

		component: {
			models: function () {
				return components;
			},

			export: exportComponent
		},

		page: {
			models: function () {
				return pages;
			},

			export: exportPage,

			checkForPage: checkForPage
		},

		start: start
	});

	window.cloneCoordsTemplate = function (coordsData) {
		var itemTemplate = $(".add-modify-page-inner-geofence-ctn-location-item-template");
		var id = $(".add-modify-page-inner-geofence-ctn-location-item").length + 1;
		var clone = itemTemplate.clone();
		clone.removeClass("add-modify-page-inner-geofence-ctn-location-item-template").addClass("add-modify-page-inner-geofence-ctn-location-item");
		clone.attr("id", "buildingId" + id);
		clone.attr("geofence-data", coordsData.coords);
		clone.find(".first").html(coordsData.name);
		clone.show();

		clone.appendTo("#geofence-list-inner");
		return clone;
	}

	// window.addNFCInInput=function(id,div){
	// try {
	// 	var jsonObject = JSON.parse($("input[name='nfcs-details']").val());

	// 	jsonObject[`${id}`]={deleted:false,field31:div.parent().parent().parent().parent().attr("data-id")};

	// 	$("input[name='nfcs-details']").val(JSON.stringify(jsonObject));
	// } catch (error) {
	// 	var jsonObject = {};

	// 	jsonObject[`${id}`]={deleted:false,field31:div.parent().parent().parent().parent().attr("data-id")};

	// 	$("input[name='nfcs-details']").val(JSON.stringify(jsonObject));
	// }
	// }

	window.updateNFCSelects = function () {
		const ids = $(`.js-nfc-list-item-delete`).map((_, el) => Number(el.dataset.id)).get();
		$('[name="nfc-tag"] option').prop('disabled', false).show();
		ids.forEach(id => {
			$(`[name="nfc-tag"] option[value="${id}"]`).prop('disabled', true).hide();
		});
	}

	window.onRemoveNFCClick = function ({ currentTarget }) {
		const li = $(currentTarget).closest('li');
		const id = li.find(".js-nfc-list-item-delete").attr("data-id");
		li.remove();

		window.parent.updateNFCSelects();
	}
	window.updateHiddenSelect2 = function (item) {
		var selects = item.find(".form-select-ctn");

		$(selects).each((i, el) => {
			var selectDiv = $(el);

			var id = selectDiv.find(".updated-select-input").attr("id");
			var name = selectDiv.find(".updated-select-input").attr("name");
			var dataId = selectDiv.find(".updated-select-input").attr("data-id");
			var dataExtra = selectDiv.find(".updated-select-input").attr("data-extra");
			var isRequired = selectDiv.find(".updated-select-input").hasClass("required");
			var disabled = selectDiv.find(".updated-select-input").attr("disabled");

			selectDiv.find(".updated-select-input").remove();

			selectDiv.find(".select2.select2-container.select2-container--default").remove();

			var select = selectDiv.find(".updated-select-input-hidden").clone();
			select.removeClass("updated-select-input-hidden").addClass("updated-select-input");

			if (id !== undefined)
				select.attr("id", id);
			if (name !== undefined) {
				select.attr("name", name);
			} if (dataId !== undefined)
				select.attr("data-id", dataId);
			if (dataExtra !== undefined)
				select.attr("data-extra", dataExtra);
			if (isRequired)
				select.addClass("required");
			if (disabled !== undefined)
				select.attr("disabled", disabled);

			select.addClass("form-select form-input");
			select.removeClass("updated-select-input-hidden").addClass("updated-select-input");
			select.appendTo(selectDiv);

			window.parent.initializeSelect2(select);
		});
	}

	window.updateHiddenSelect = function (item, newId) {
		var selectDiv = $(item).find(".form-select-ctn");

		var id = selectDiv.find(".updated-select-input").attr("id");
		var name = selectDiv.find(".updated-select-input").attr("name");
		var dataId = selectDiv.find(".updated-select-input").attr("data-id");
		var dataExtra = selectDiv.find(".updated-select-input").attr("data-extra");
		var isRequired = selectDiv.find(".updated-select-input").hasClass("required");
		var disabled = selectDiv.find(".updated-select-input").attr("disabled");

		selectDiv.find(".updated-select-input").remove();

		selectDiv.find(".select2.select2-container.select2-container--default").remove();

		var select = selectDiv.find(".updated-select-input-hidden").clone();
		select.removeClass("updated-select-input-hidden").addClass("updated-select-input");

		if (id !== undefined)
			select.attr("id", id + "-" + newId);
		if (name !== undefined) {
			select.attr("name", name);
		} if (dataId !== undefined)
			select.attr("data-id", dataId);
		if (dataExtra !== undefined)
			select.attr("data-extra", dataExtra);
		if (isRequired)
			select.addClass("required");
		if (disabled !== undefined)
			select.attr("disabled", disabled);
		select.addClass("form-select form-input");

		var isRequired = selectDiv.find(".updated-select-input").hasClass("required");
		var disabled = selectDiv.find(".updated-select-input").attr("disabled");

		select.appendTo(selectDiv);
		window.parent.initializeSelect2(select);
	}

	window.addComponent = function (dropdownOption, containerId) {
		return window.parent.addGenComponent(dropdownOption, "responseOption", "containerId" + containerId, "response-type-container-item", ".add-response-edit-location", null);
	}

	window.addPictureComponent = function (filename, containerId, filenameGen) {
		var id = window.parent.addGenComponent(filename, "pictureLi", "pictureContainerId" + containerId, "picture-container-item", ".add-picture-edit-location", filenameGen);
		return id;
	}

	window.addGenComponent = function (cName, cPrefix, containerId, containerCls, editBtnCls, cFilename) {
		var container = $("." + containerId);
		var totalEle = container.find("." + containerCls).length;
		var cClone = $("." + containerCls + "-hidden").clone();
		var textBoxId = cPrefix + totalEle + containerId;
		cClone.removeClass(containerCls + "-hidden").addClass(containerCls);

		cClone.find(".first").html(cName);
		cClone.find(".first").addClass(textBoxId);
		cClone.find(editBtnCls).attr("data-str-box-id", textBoxId);

		if (cFilename)
			cClone.find(editBtnCls).attr("data-filename", cFilename);

		container.append(cClone);
		return textBoxId;
	}


	window.convertDivToBase64Image = function (divId, width, height) {
		return new Promise((resolve, reject) => {
			const tableDiv = document.getElementById(divId);
			if (!tableDiv) {
				console.error(`Element with ID ${divId} not found`);
				resolve(null);
				return;
			}

			const svgElement = tableDiv.querySelector("svg");

			if (svgElement) {
				// ✅ Handle SVG Conversion
				try {
					const svgString = new XMLSerializer().serializeToString(svgElement);
					const base64 = btoa(unescape(encodeURIComponent(svgString)));
					const svgData = `data:image/svg+xml;base64,${base64}`;

					var canvas = document.createElement("canvas");
					var context = canvas.getContext("2d");

					canvas.width = width;
					canvas.height = height;

					var image = new Image();

					image.onload = function () {
						context.clearRect(0, 0, width, height);
						context.drawImage(image, 0, 0, width, height);
						var pngData = canvas.toDataURL("image/png");
						resolve(pngData);
					};

					image.onerror = function () {
						console.error("Error loading SVG image");
						resolve(null);
					};

					image.src = svgData;
				} catch (error) {
					console.error("Error converting SVG to Base64:", error);
					resolve(null);
				}
			} else {
				// ✅ Handle HTML Elements using `html2canvas`
				html2canvas(tableDiv, {
					backgroundColor: null, // Transparent background
					width: width,
					height: height,
					scale: 2, // High-resolution capture
				}).then((canvas) => {
					resolve(canvas.toDataURL("image/png"));
				}).catch((error) => {
					console.error("Error capturing div with html2canvas:", error);
					resolve(null);
				});
			}
		});
	};

	$(document).on("click", ".dt-download-btn", async function (e) {
		const btn = $(e.currentTarget);
		const table = $("#" + btn.attr("aria-controls"));
		const chart = table.attr("chart");

		const img = await window.parent.convertDivToBase64Image(chart, 1280, 900);
		var image = new Image();
		image.src = img;
		image.id = btn.attr("aria-controls") + "-chartImg";
		image.classList.add("d-none");

		if (table.find("#" + btn.attr("aria-controls") + "-chartImg"))
			table.find("#" + btn.attr("aria-controls") + "-chartImg").remove();

		table.prepend(image);
	});

	window.initializeISelectMultiple = function (select, field, viewField, prefix, postfix) {

		// This is your onChange callback.
		function treeOnChange(allSelectedItems, addedItems, removedItems) {
			if (viewField !== undefined) {
				// Set total selected items on view field.
				$(viewField).val(prefix + allSelectedItems.length + postfix);
			}
			if (field !== undefined) {
				// Set total selected items ids on hidden input field.
				$(field).val(allSelectedItems.map(obj => obj.value).join(","));

				populateUsersOnLocations(field);
			}
		}

		// Initialize the treeMultiselect.
		$(select ? select : ".iselect-multiple").treeMultiselect({
			searchable: true,
			searchParams: ['section', 'text'],
			onChange: treeOnChange,
			startCollapsed: true,
			enableSelectAll: true
		});

		// Run the populate function on page load as well.
		populateUsersOnLocations(field);
	};

	function populateUsersOnLocations(field) {
		if (field === "#reminder-checklists") {
			var checkedLabels = [];

			// Assuming the tree-multiselect container is the div immediately following #checklistsList2.
			$('#checklistsList2')
				.next('div')
				.find('.title')
				.each(function () {
					var $checkbox = $(this).find('input[type="checkbox"]');
					if ($checkbox.is(':checked')) {
						// Collect the trimmed text from each .title.
						checkedLabels.push($.trim($(this).text()));
					}
				});

			// Create a comma-separated string from the checked labels.
			var checkedString = checkedLabels.join(',');

			$.ajax({
				url: '/action/sbReminderUsers',
				type: 'POST',
				data: { Locations: checkedString },
				success: function (response) {

					var isMultiple = checkedString.indexOf(',') !== -1;
					var heading;

					if (document.documentElement.lang === 'fr') {
						heading = "Utilisateurs de l'emplacement" + (isMultiple ? "s" : "");
					} else {
						heading = (isMultiple ? "Locations" : "Location") + " Users";
					}

					var headingHtml = '<p><strong>' + heading + '</strong></p>';



					// If the response is empty ("" or empty array), display only the heading.
					if (!response || (typeof response === "string" && response.trim() === "") || (Array.isArray(response) && response.length === 0)) {
						$('#response-forward__persons').html(headingHtml);
						return;
					}

					// Sort the response array by full_name (alphabetically, case-insensitive)
					response.sort(function (a, b) {
						var nameA = a.full_name.toUpperCase();
						var nameB = b.full_name.toUpperCase();
						if (nameA < nameB) return -1;
						if (nameA > nameB) return 1;
						return 0;
					});

					// Start building the HTML output.
					var html = headingHtml;

					// Iterate through each user in the sorted response.
					$.each(response, function (index, user) {
						html += '<label class="form-checkbox-ctn response-forward__person" style="display:block; margin-bottom:10px;">';

						// Add the toggle button as the very first element.
						html += '<span class="toggle-arrow" style="cursor:pointer; background:#777; color:#fff; padding:2px 5px; display:inline-block; margin-right:5px;">+</span>';

						// Build the checkbox input.
						html += '<input type="checkbox" class="form-check-input response-forward__person-check reminder-field" ' +
							'name="response-forward-person" ' +
							'data-field1="' + user.person_id + '" ' +
							'data-field2="' + user.email + '" ' +
							'value="' + user.email + ' - ' + user.locations + '">';

						// Add the span for the checkbox graphic (using your SVG).
						html += '<span class="form-checkbox" style="vertical-align:middle; margin-left:5px;">';
						html += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="33.65px" height="25.86px" viewBox="0 0 33.65 25.86" xml:space="preserve">';
						html += '<polyline fill="none" stroke="#000000" stroke-width="8" stroke-miterlimit="10" points="2.7,11.21 12.7,20.38 30.87,2.88"></polyline>';
						html += '</svg>';
						html += '</span>';

						// Build the text span: show the full name only on the main label.
						html += '<span style="margin-left:10px; vertical-align:middle;">';
						html += '<strong>' + user.full_name + '</strong>';
						html += '</span>';

						// Build the tree view container which will include the email and locations.
						var treeHtml = '<ul style="list-style-type:none; padding:0; margin:0;">';
						// First list item: the email with a bottom border acting as a separator.
						treeHtml += '<li style="border-bottom: 1px solid #ccc; padding-bottom:5px; margin-bottom:5px;">' + user.email + '</li>';
						// Next, split the locations string into an array and list them.
						var locArray = user.locations.split(',');
						$.each(locArray, function (i, loc) {
							treeHtml += '<li>' + $.trim(loc) + '</li>';
						});
						treeHtml += '</ul>';

						// Add the locations container (initially hidden) containing the tree view.
						html += '<div class="locations-container" style="display:none; margin-left:40px; margin-top:5px;">' + treeHtml + '</div>';

						html += '</label>';
					});

					// Insert the generated HTML into the container.
					$('#response-forward__persons').html(html);
				},
				error: function (xhr, status, error) {
					console.error('AJAX call failed:', error);
				}
			});
		}
	}

	// Delegate a click event to toggle the location container.
	$(document).on('click', '.toggle-arrow', function (e) {
		e.preventDefault();
		e.stopPropagation();

		var $this = $(this);
		var $container = $this.closest('label').find('.locations-container');
		$container.slideToggle('fast', function () {
			if ($container.is(':visible')) {
				$this.text("–");
			} else {
				$this.text("+");
			}
		});
	});

	function formatDate(dateStr) {
		// Remove ordinal suffixes (st, nd, rd, th)
		const sanitizedDateStr = dateStr.replace(/\b(\d{1,2})(st|nd|rd|th)\b/, "$1");
	
		// Parse the cleaned date string
		const date = new Date(sanitizedDateStr);
	
		// Check if the date is valid
		if (isNaN(date.getTime())) {
			console.error("Invalid date format:", dateStr);
			return "Invalid Date";
		}
	
		const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		const day = ("0" + date.getDate()).slice(-2);
		const month = monthNames[date.getMonth()];
		const year = date.getFullYear();
	
		return `${month}${day}-${year}`;
	}

	window.initializeDataTable = function (table) {
		if (table.hasClass("with-chart"))
			return table.DataTable({
				lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
				layout: {
					topStart: {
						buttons: ["pageLength",
							{
								extend: 'collection',
								text: 'Download',
								attr: {
									class: "dt-button buttons-collection dt-download-btn",
								},
								buttons: ['excelHtml5', 'csvHtml5', {
									extend: 'pdfHtml5',
									filename: function () {
										var locations = [];
										$('#checklistsList1')
											.next('div')
											.find('.title')
											.each(function () {
												var $checkbox = $(this).find('input[type="checkbox"]');
												if ($checkbox.is(':checked')) {
													locations.push($.trim($(this).text()));
												}
											});
								
										var firstLocation = locations.length > 0 ? locations[0] : "No Locations Selected";
										var locationName = locations.length > 1 ? `${firstLocation}-Et-al` : firstLocation;
								
										var dateRangeStr = $("#" + table.attr("include")).val(); 
										var dates = dateRangeStr.split(" - ");
										var startDate = formatDate(dates[0]);
										var endDate = formatDate(dates[1]);
										var dateRange = `${startDate} - ${endDate}`;
								
										return table.attr("report-title").includes("NFCs") 
											? `${locationName}_Concerns-${dateRange}`
											: `${locationName}_Activity-${dateRange}`;

									},
									title: function () {
										return table.attr("report-title"); // Keep only the default report title
									},
									customize: function (doc) {
										const pageWidth = doc.pageSize.width;
									
										// ✅ Step 1: Remove Auto-Inserted Title to Prevent Duplication
										let titleIndex = doc.content.findIndex(item =>
											typeof item.text === "string" && item.text.includes(table.attr("report-title"))
										);
									
										if (titleIndex !== -1) {
											doc.content.splice(titleIndex, 1); // Remove only the first occurrence
										}
									
										// ✅ Step 2: Keep Logo at the Top
										doc['header'] = function (currentPage) {
											if (currentPage === 1) {
												return {
													columns: [
														{
															image: $("#logoBase64").attr("src"),
															width: 400, // Proper scaling
															alignment: 'center'
														}
													],
													margin: [90, 10, 0, 0] // Adjust spacing
												};
											} else return null;
										};
									
										// ✅ Step 3: Insert Report Title Below the Logo
										doc.content.unshift({
											text: table.attr("report-title").includes("Completed") ? "Activity " + $("#" + table.attr("include")).val() : "Concerns " + $("#" + table.attr("include")).val(),
											fontSize: 16,
											bold: true,
											alignment: 'center',
											margin: [0, 60, 0, 40] // Space between logo and title
										});
									
										doc.content.push({
											table: {
												widths: ['50%'], 
												body: [
													[
														{
															text: "Kera Insight",
															fontWeight: 500,
															fontSize: 30,
															textTransform: "none", 
															fontFamily: "Lato,arial,helvetica,sans-serif",
															bold: true,
															color: "#34446e", 
															alignment: "center",
															margin: [0, 20, 0, 5] 
														}
													],
													[
														{
															text: "(Pure Data Analytics - Real Results)",
															fontWeight: 350,
															fontSize: 10,
															textTransform: "none", 
															fontFamily: "Lato,arial,helvetica,sans-serif",
															italics: true,
															color: "#34446e",
															alignment: "center",
															margin: [0, -10, 0, 10] 
														}
													]
												]
											},
											layout: {
												hLineWidth: function () { return 0; },
												vLineWidth: function () { return 0; },
												paddingLeft: function () { return 2; },
												paddingRight: function () { return 2; },
												paddingTop: function () { return 2; },
												paddingBottom: function () { return 2; }
											},
											margin: [-60, -50, 0, 40]
										});
										
										
										// ✅ Step 5: Insert Chart Below the Heading
										doc.content.push({
											alignment: 'center',
											image: $("#" + table.attr("id") + "-chartImg").attr("src"),
											width: 500, // Ensures proper scaling
											margin: [0, -40, 0, 40] // Space between heading and chart
										});
									
										// ✅ Step 6: Move Table Below the Chart
										let tableIndex = doc.content.findIndex(item => item.table);

										if (tableIndex !== -1) {
											let tableContent = doc.content[tableIndex];
										
											// ✅ Ensure new row has the same column count as the existing table
											let columnCount = tableContent.table.body[0].length;
										
											// ✅ Create a row with a single merged cell
											let mergedRow = [
												{
													text: "Click here for detailed Kera Insight",
													link: "https://devbiz.safebuildingsapp.ca",
													color: "blue",
													decoration: "underline",
													alignment: "center",
													colSpan: columnCount, // Merges all columns
												}
											];
										
											// ✅ Fill remaining columns with empty objects (needed to maintain structure)
											for (let i = 1; i < columnCount; i++) {
												mergedRow.push({});
											}
										
											// ✅ Append the merged row at the end
											tableContent.table.body.push(mergedRow);
										}
										

										if (tableIndex !== -1) {
											let tableContent = doc.content.splice(tableIndex, 1)[0]; // Remove table from old position
											doc.content.push(tableContent); // Add table at the bottom
										}
									}
								}]
							}
						]
					}
				}
			});
		else
			return table.DataTable({
				lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
				layout: {
					topStart: {
						buttons: ["pageLength",
							{
								extend: 'collection',
								text: 'Download',
								buttons: ['excelHtml5', 'csvHtml5', 'pdfHtml5']
							}
						]
					}
				}
			});
	};


	window.filterByJson = function (searchTerm, table, tableId) {
		searchTerm = String(searchTerm).toLowerCase();
		$.fn.dataTable.ext.search.push(
			function (settings, data, dataIndex) {
				if (settings.nTable.id !== tableId) {
					for (var i = 0; i < data.length; i++) {
						if (data[i].toLowerCase().includes(searchTerm)) {
							return true;
						}
					}
				} else {
					try {
						var rowNode = settings.aoData[dataIndex].nTr;
						var questions = JSON.parse(JSON.parse($(rowNode).data('json'))).questions;
						var questionsStr = String(questions.map((u) => u.name).join(",")).toLowerCase();

						if (questionsStr.includes(searchTerm)) {
							return true;
						}

						for (var i = 0; i < data.length; i++) {
							if (data[i].toLowerCase().includes(searchTerm)) {
								return true;
							}
						}
					} catch (error) {
						for (var i = 0; i < data.length; i++) {
							if (data[i].toLowerCase().includes(searchTerm)) {
								return true;
							}
						}
					}
				}
			}
		);
		table.draw();
		$.fn.dataTable.ext.search.pop();
	}
	window.initializeMultiSelect2 = function (select) {

		function stripDiacritics(text) {
			function match(a) {
				return DIACRITICS[a] || a;
			}

			return text.replace(/[^\u0000-\u007E]/g, match);
		}

		function matcher(params, data) {
			if (params.term == null || params.term.trim() === '') {
				return data;
			}

			if (data.children && data.children.length > 0) {
				var match = $.extend(true, {}, data);

				for (var c = data.children.length - 1; c >= 0; c--) {
					var child = data.children[c];

					var matches = matcher(params, child);

					if (matches == null) {
						match.children.splice(c, 1);
					}
				}

				if (match.children.length > 0) {
					return match;
				}

				return matcher(params, match);
			}

			var original = stripDiacritics(data.text).toUpperCase();
			var term = stripDiacritics(params.term).toUpperCase();

			if (original.indexOf(term) > -1) {
				return data;
			}
			return null;
		}

		function checkboxWithOpt(state, classes, inputsSelected) {
			var id = state.id ? state.id.toLowerCase() : state.element.getAttribute("value");

			var label = '<label for="' + id + '">' + state.text + '</label>';
			var selected = state.selected;

			if (state.children)
				if (inputsSelected) {
					const inputSelected = inputsSelected.get('optgroup-' + id + "-input");

					if (inputSelected != undefined && inputSelected.id != undefined && inputSelected.id == 'optgroup-' + id + "-input") {
						selected = inputSelected.selected;
					}
				}

			return $(
				'<div class="sb-readonly-checkbox' + (state.children ? ' sb-cursor-pointer optgroup-checkbox" '
					+ 'select-id="' + $(state.element).parent().attr("id") + '" parent-id="optgroup-' + id : ' option-checkbox" '
					+ 'parent-id="optgroup-' + $(state.element).parent().attr("value")) + '">'

				+ '<div class="sb-readonly-checkbox-inner"></div>'
				+ '<div class="sb-d-flex">'
				+ '<div class="sb-flex1">'
				+ '<input ' + (selected ? 'checked="checkekd"' : '') + ' data-id="' + id + '" type="checkbox" class="' + classes + '" ' +
				(state.children ? ' id="optgroup-' + id + '-input"' : 'id="optioncheckbox-' + id + '"') + '>'
				+ '</div>'
				+ '<div class="sb-flex99">'
				+ label
				+ "</div>"
				+ "</div>"
				+ '</div>');
		}

		function callSelect2(select, inputsSelected) {
			select.select2({
				dropdownAutoWidth: true,
				width: '100%',
				matcher: matcher,
				templateResult: (state) => {
					if (!state.id) {
						if (state.children) {
							return checkboxWithOpt(state, 'optgroup-checkbox', inputsSelected);
						} else
							return state.text;
					}
					return checkboxWithOpt(state, "optgroup-" + $(state.element).parent().attr("value"), inputsSelected);
				},
				templateSelection: (state) => {
					const id = state.id;
					$("#optioncheckbox-" + String(id).toLocaleLowerCase()).attr("checked", true);
					return state.text;
				},
				closeOnSelect: false,
				escapeMarkup: function (m) {
					return m;
				},
			}).on('select2:unselect', function (e) {
				var data = e.params.data;
				$("#optioncheckbox-" + String(data.id).toLocaleLowerCase()).attr("checked", false);
			});

			var container = $(select).siblings('.select2-container');
			$(container).find(".select2-selection").css({
				'min-height': '47px', 'border': '1px solid #cbccd9',
				'background-color': 'inherit', 'font-size': '1.4rem',
				'font-family': 'Lato,arial,helvetica,sans-serif'
			});
			$(container).find('.select2-selection__arrow').css({ 'height': '44px', 'right': '10' });
		}

		callSelect2(select);

		$(document).on("click", ".option-checkbox", function (e) {
			const option = $(e.currentTarget);
			const id = option.attr("parent-id");
			const parentDiv = $("optgroup[value='" + String(id).replace("optgroup-", "") + "']");
			const parentDivInput = $("#" + id + "-input");
			const children = $("." + id + ":checked");
			console.warn(children.length + ":" + parentDiv.children().length);
			if (children)
				parentDivInput.prop("checked", children.length == parentDiv.children().length)
		});

		$(document).on("click", ".optgroup-checkbox", function (e) {
			const parentDiv = $(e.currentTarget)
			const id = parentDiv.attr("parent-id");
			const selectId = parentDiv.attr("select-id");
			const children = $("." + id);
			const parentDivInput = $("#" + id + "-input")
			const checked = parentDivInput.prop("checked");

			if (children) {
				children.prop("checked", !checked);

				var optgroups = new Map();
				$(".optgroup-checkbox").each((i, e) => {
					var nI = $(e).attr("id");
					if (nI != undefined && !optgroups.has(id))
						optgroups.set(nI, { id: nI, selected: nI == id + "-input" ? !checked : $(e).prop("checked") });
				});

				if (checked) {
					var unselectValues = children.map(function (i, v) {
						return String($(v).attr("data-id")).toUpperCase();
					}).get();

					var selectedValues = $('#' + selectId).val().filter((v) => {
						return !unselectValues.includes(v);
					});

					callSelect2($('#' + selectId).val(selectedValues), optgroups)
				} else {
					var selectedValues = [];
					children.each((i, v) => {
						selectedValues.push(String($(v).attr("data-id")).toUpperCase());
					});

					callSelect2($('#' + selectId).val($('#' + selectId).val().concat(selectedValues)), optgroups);
				}
			}
		});

		$(document).on("click", ".optgroup-checkbox", function (e) {
			const parentDiv = $(e.currentTarget)
			const id = parentDiv.attr("parent-id");
			const selectId = parentDiv.attr("select-id");
			const children = $("." + id);
			const parentDivInput = $("#" + id + "-input")
			const checked = parentDivInput.prop("checked");

			if (children) {
				children.prop("checked", !checked);

				var optgroups = new Map();
				$(".optgroup-checkbox").each((i, e) => {
					var nI = $(e).attr("id");
					if (nI != undefined && !optgroups.has(id))
						optgroups.set(nI, { id: nI, selected: nI == id + "-input" ? !checked : $(e).prop("checked") });
				});

				if (checked) {
					var unselectValues = children.map(function (i, v) {
						return String($(v).attr("data-id")).toUpperCase();
					}).get();

					var selectedValues = $('#' + selectId).val().filter((v) => {
						console.warn(v);
						return !unselectValues.includes(v);
					});

					callSelect2($('#' + selectId).val(selectedValues), optgroups)
				} else {
					var selectedValues = [];
					children.each((i, v) => {
						selectedValues.push(String($(v).attr("data-id")).toUpperCase());
					});

					callSelect2($('#' + selectId).val($('#' + selectId).val().concat(selectedValues)), optgroups);
				}
			}
		});

		callSelect2(select);
	}

	window.initializeSelect2 = function (select) {
		var disableOrderwise = select.attr("disable-orderwise");
		var dataOptions = select.attr("dataoptions");
		var selectedoption = select.attr("selectedoption");
		if (dataOptions != undefined && dataOptions != null && dataOptions) {
			dataOptions = JSON.parse(dataOptions);

			for (var i = 0; i < dataOptions.length; i++) {
				var strrr = (selectedoption != undefined && selectedoption != null && selectedoption == dataOptions[i] ? "selected='selected'" : "");
				select.append("<option value='" + dataOptions[i] + "' " + strrr + ">" + dataOptions[i] + "</option>");
			}
		}

		if (disableOrderwise == 'true') {
			if ($(select).hasClass("select2-multiple"))
				window.parent.initializeMultiSelect2(select);
			else
				select.select2();
		} else {
			if ($(select).hasClass("select2-multiple"))
				window.parent.initializeMultiSelect2(select);
			else
				select.select2({
					sorter: data => {
						var firstItem = data.shift();
						var tempData = data.sort((a, b) => a.text.localeCompare(b.text));
						tempData.unshift(firstItem);
						return tempData;
					}
				});
		}

		var container = $(select).siblings('.select2-container');
		if (!($(select).hasClass("select2-multiple"))) {
			if ($(select).parent().hasClass("sb-w100")) {
				container.addClass("sb-100w");
			} else if ($(select).parent().hasClass("half") || $(select).parent().parent().hasClass("half")) {
				container.css({ 'display': 'block', 'max-width': '100%', 'width': '100%', 'min-width': '100%' });
			} else if ($(select).parent().hasClass("two-third") || $(select).parent().hasClass("third")) {
				container.css({ 'max-width': '100%', "width": "100%" });
			} else if ($(select).parent().hasClass("sb-150px")) {
				container.css({ "width": "150px" });
			} else {
				container.css({
					'width':
						$(select).parent().hasClass("fill") || $(select).parent().parent().hasClass("fill") ?
							'100%' : $(select).css('width') == '' || $(select).css('width') == '1px' ?
								($(select).css('min-width') == '' ? select.css('max-width') : select.css('min-width')) : $(select).css('width')
				});
			}
			$(container).find(".select2-selection").css({ 'height': '47px', 'border': '1px solid #cbccd9', 'background-color': 'inherit', 'font-size': '1.4rem', 'font-family': 'Lato,arial,helvetica,sans-serif' });
			$(container).find('.select2-selection__arrow').css({ 'height': '44px', 'right': '10' });
			$(container).find('.select2-selection__rendered').css({ 'line-height': '44px', 'padding-left': '18px' });
		}
	}
})(jQuery, window);